import { useCurrentUser } from '@bizzabo/entities';
import { BaseButton, UserIcon } from '@bizzabo/design-system';

import useTypeTracking from '../../../../analytics';
import { useUserSettings } from '../../../../settingsNav';
import { BUTTON_TYPE, CATEGORIES } from '../../hooks/useProfileAnalytics';

export const ShowProfileModalButton: React.FC<{ eventId: number }> = ({ eventId }) => {
    const { openUserProfile } = useUserSettings();
    const { data: currentUser, isLoading, error } = useCurrentUser(eventId);
    const { trackClickEvent } = useTypeTracking();

    const handleClick = () => {
        trackClickEvent({
            buttonType: BUTTON_TYPE,
            subCategory: CATEGORIES.open,
        });
        openUserProfile();
    };

    if (isLoading || error) {
        return null;
    }
    return (
        <BaseButton onClick={handleClick}>
            <UserIcon photoUrl={currentUser.photoUrl} />
        </BaseButton>
    );
};
